import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { createBuilding } from "../../../../api/building";
import { Button } from "../../../common/Button";
import { sectionToIcon } from "../../../type/default";
import {
  BuildingFields,
  EMPTY_BUILDING_FORM,
  toCreateBuilding,
  useBuildingForm,
} from "../../building/BuildingFields";
import { SetupError } from "../../setup/SetupLayout";
import { DetailCard } from "./DetailCard";

/** Bouton « Ajouter un bâtiment » qui se déplie en formulaire. */
export const AddBuildingCard = ({
  breedingId,
  onCreated,
}: {
  breedingId: number;
  onCreated: () => Promise<void>;
}) => {
  const { t } = useTranslation();
  const buildingForm = useBuildingForm(EMPTY_BUILDING_FORM);
  const [isOpen, setIsOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const close = () => {
    buildingForm.reset(EMPTY_BUILDING_FORM);
    setError("");
    setIsOpen(false);
  };

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!buildingForm.validate()) return;

    setSubmitting(true);
    const result = await createBuilding(
      toCreateBuilding(buildingForm.form, breedingId)
    );
    if (!result.success) {
      setSubmitting(false);
      setError(t("setup-error-building"));
      return;
    }
    await onCreated();
    setSubmitting(false);
    close();
  };

  if (!isOpen) {
    return (
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="w-full flex items-center justify-center gap-2 rounded-xl border-2 border-dashed border-grey-medium py-4 text-grey-medium font-oxaniumMedium hover:border-secondary hover:text-secondary transition-colors"
      >
        <FontAwesomeIcon icon="plus" />
        {t("breeding-detail-add-building")}
      </button>
    );
  }

  return (
    <DetailCard
      title={t("breeding-detail-add-building")}
      icon={sectionToIcon.section_building}
    >
      <form onSubmit={submit}>
        {error && (
          <div className="mb-3">
            <SetupError message={error} />
          </div>
        )}
        <BuildingFields buildingForm={buildingForm} layout="row" />
        <div className="flex justify-end gap-2 pt-3">
          <Button
            type="button"
            variant="secondary"
            size="small"
            onClick={close}
          >
            {t("button-cancel")}
          </Button>
          <Button type="submit" size="small" disabled={submitting}>
            {submitting ? t("setup-saving") : t("setup-buildings-add")}
          </Button>
        </div>
      </form>
    </DetailCard>
  );
};
